export default "<div class=\"avatar-initials-icon\" [slot]=\"slot\" [ngStyle]=\"hslColor\">\n  {{ initials | uppercase }}\n</div>";